import React, { useState, useEffect } from 'react';

const getTimeOfDay = () => {
  const h = new Date().getHours();
  if (h >= 6 && h < 12) return 'morning';
  if (h >= 12 && h < 18) return 'afternoon';
  if (h >= 18 && h < 22) return 'evening';
  return 'night';
};

const overlays = {
  morning: 'linear-gradient(180deg, rgba(255,183,77,0.04) 0%, rgba(255,138,48,0.02) 40%, transparent 70%)',
  afternoon: 'linear-gradient(180deg, rgba(66,165,245,0.03) 0%, rgba(41,182,246,0.02) 40%, transparent 70%)',
  evening: 'linear-gradient(180deg, rgba(255,112,67,0.06) 0%, rgba(171,71,188,0.03) 40%, transparent 70%)',
  night: 'none',
};

const TimeOverlay = () => {
  const [tod, setTod] = useState(getTimeOfDay());

  useEffect(() => {
    const interval = setInterval(() => setTod(getTimeOfDay()), 60000);
    return () => clearInterval(interval);
  }, []);

  if (tod === 'night') return null;

  return (
    <div
      className="fixed inset-0 pointer-events-none z-[1]"
      style={{ background: overlays[tod] }}
      data-testid="time-overlay"
    />
  );
};

export default TimeOverlay;
